<template>
  <div class="f_confirm_pay">
    <!-- //头部 -->
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize sub_icon"></i>
        订单确认
        <div class="rutun" @click="setPage(1)">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div class="refresh_text">刷新</div>
        </div>
      </div>
    </div>

    <!-- //版心部分 -->
    <div class="table_area">
      <!-- //搜索模块 -->
      <div class="search_title">筛选查询</div>
      <div class="clearfix">
        <el-row type="flex" align="middle" class="search_box">
          <el-col :span="2" class="search_label">订单编号:</el-col>
          <el-col :span="4">
            <el-input clearable size="small" v-model="orderCode"></el-input>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="5">
            <el-button size="small" @click="geting()">搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <!-- //表格部分 -->
      <div class="content_box">
        <div class="table_title">
          <div class="table_title_box">
            <div class="title_icon">
              <i class="fas fa-bars"></i>
            </div>
            <div class="title_text">数据列表</div>
          </div>
        </div>
        <div class="table">
          <el-table :data="tableData" border class="table_w">
            <el-table-column prop="orderCode" width="200" label="订单编号" align="center"></el-table-column>
            <el-table-column prop="create_time" width="200" label="下单时间" align="center"></el-table-column>
            <el-table-column prop="pay_type" label="支付类型" align="center"></el-table-column>
            <el-table-column prop="payway" label="支付方式" align="center"></el-table-column>
            <el-table-column prop="pay_money" label="金额" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" align="center"></el-table-column>
            <el-table-column  label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  @click="payOrderCode = scope.row.orderCode,showPayForm = true"
                >确认付款</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box clearfix">
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              :current-page.sync="page"
              @current-change="setPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="付款信息" :visible.sync="showPayForm" width="500px">
      <el-form>
        <el-form-item label="付款金额:" label-width="80px">
          <el-input v-model="payMoney" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showPayForm = false">取 消</el-button>
        <el-button type="primary" @click="confirmPay()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "./../../assets/all.css";
export default {
  name: "f_confirm_pay",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      tableData: [],
      orderCode: "",
      showPayForm: false,
      payOrderCode: "",
      payMoney: "",
      total: 0,
      page: 1
    };
  },
  created() {
    this.$store.state.topActiveId = 11;
    this.$store.state.leftTitle = "支付确认";
    this.geting(1);
  },
  mounted() {},
  methods: {
    confirmPay() {
      if (!this.payMoney) {
        this.$message.error("请输入付款金额");
        return;
      }
      var where = {
        username: this.username,
        token: this.token,
        orderCode: this.payOrderCode,
        input_money: this.payMoney
      };
      this.axios
        .get(this.serve + "/admin/admin_pay", {
          params: where
        })
        .then(res => {
          if (res.data.status == "success") {
            this.showPayForm = false;
            this.payOrderCode = "";
            this.payMoney = "";
            this.geting();
            this.$message({
              type: "success",
              message: "确认付款成功"
            });
          } else if (res.data.status == "error") {
            this.geting();
            this.$message.error("操作失败");
          }
        });
    },
    setPage(v) {
      //分页
      this.page = Number(v);
      this.geting(v);
    },

    geting(page) {
      var where = {
        username: this.username,
        token: this.token,
        page:page
      };

      if(this.orderCode){
          where.orderCode = this.orderCode
      }
      this.axios
        .get(this.serve + "/admin/wait_pay_order", {
          params: where
        })
        .then(res => {
          this.tableData = [];
          if (res.data.status == "success") {
            this.tableData = res.data.data.results;
            this.total = res.data.data.total;
          } else {
          }
        });
    }
  }
};
</script>
<style lang="scss">
.f_confirm_pay {
}
</style>